(function () {
  'use strict';

  var form = document.querySelector('[data-plp-form]');
  if (!form) return;

  function spiegel(e) {
    var bron = e.target;
    if (!bron.name || bron.name.indexOf('filter.') !== 0) return;
    form.querySelectorAll('[name="' + CSS.escape(bron.name) + '"]').forEach(function (el) {
      if (el === bron) return;
      if (bron.type === 'checkbox' || bron.type === 'radio') {
        if (el.value === bron.value) el.checked = bron.checked;
      } else if (el.value !== bron.value) {
        el.value = bron.value;
      }
    });
  }
  form.addEventListener('input', spiegel);
  form.addEventListener('change', spiegel);

  var wacht;
  form.addEventListener('change', function (e) {
    var veld = e.target;
    if (!veld.name) return;
    var doel = veld.form || form;
    if (veld.type === 'number') {
      clearTimeout(wacht);
      wacht = setTimeout(function () { doel.submit(); }, 600);
      return;
    }
    doel.submit();
  });

  document.addEventListener('submit', function () { clearTimeout(wacht); }, true);

  var intro = document.querySelector('[data-plp-intro]');
  var meer = document.querySelector('[data-plp-meer]');
  if (intro && meer) {
    if (intro.scrollHeight > intro.clientHeight + 1) meer.hidden = false;
    meer.addEventListener('click', function () {
      var open = meer.getAttribute('aria-expanded') !== 'true';
      intro.classList.toggle('is-open', open);
      meer.setAttribute('aria-expanded', open ? 'true' : 'false');
      meer.textContent = open ? meer.dataset.minder : meer.dataset.meer;
    });
  }

  var hulpKnop = document.querySelector('[data-plp-hulp-open]');
  var hulpVak = document.querySelector('[data-plp-hulpvak]');
  if (hulpKnop && hulpVak) {
    hulpKnop.addEventListener('click', function () {
      var open = hulpKnop.getAttribute('aria-expanded') !== 'true';
      hulpVak.classList.toggle('is-open', open);
      hulpKnop.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var veld = hulpVak.querySelector('select, input, button');
        if (veld) veld.focus({ preventScroll: true });
        hulpVak.scrollIntoView({ block: 'nearest' });
      }
    });
  }

  var paneel = document.querySelector('[data-sheet]');
  if (!paneel) return;

  function open(aan) {
    if (aan) { paneel.setAttribute('data-open', ''); }
    else { paneel.removeAttribute('data-open'); }
    document.body.style.overflow = aan ? 'hidden' : '';
    openers.forEach(function (k) { k.setAttribute('aria-expanded', aan ? 'true' : 'false'); });
    if (aan) {
      var eerste = paneel.querySelector('input, button, a');
      if (eerste) eerste.focus();
    } else if (openers[0] && paneel.contains(document.activeElement)) {
      openers[0].focus();
    }
  }
  var openers = Array.prototype.slice.call(document.querySelectorAll('[data-sheet-open]'));

  openers.forEach(function (k) {
    k.addEventListener('click', function () { open(true); });
  });
  document.querySelectorAll('[data-sheet-close]').forEach(function (k) {
    k.addEventListener('click', function () { open(false); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && paneel.hasAttribute('data-open')) open(false);
  });

  var hulp = document.querySelector('[data-keuzehulp]');
  if (!hulp) return;

  function lees(kiezer, naam) {
    var el = hulp.querySelector(kiezer);
    if (!el) {
      console.warn('[Voltrade] keuzehulp: ' + naam + ' ontbreekt in de pagina (' + kiezer + ')');
      return null;
    }
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.warn('[Voltrade] keuzehulp: ' + naam + ' is geen geldige JSON', e);
      return null;
    }
  }

  var catalogus = {};
  var kabels = lees('[data-keuzehulp-kabels]', 'de kabellijst') || [];

  var kiesMerk = hulp.querySelector('[data-fit-merk]');
  var kiesModel = hulp.querySelector('[data-fit-model]');
  var knopGo = hulp.querySelector('[data-keuzehulp-go]');
  var uit = hulp.querySelector('[data-keuzehulp-uit]');

  function vulModellen(merkHandle) {
    kiesModel.innerHTML = '';
    var modellen = catalogus[merkHandle] || [];
    var leeg = document.createElement('option');
    leeg.value = '';
    leeg.textContent = kiesModel.dataset.leeg || '';
    kiesModel.appendChild(leeg);

    modellen.forEach(function (m, i) {
      var o = document.createElement('option');
      o.value = String(i);
      o.textContent = window.VTKabel ? VTKabel.modelLabel(m) : m.naam;
      o.dataset.naam = m.naam;
      kiesModel.appendChild(o);
    });
    if (modellen.length === 0) {
      console.warn('[Voltrade] keuzehulp: geen modellen voor merk "' + merkHandle +
        '". Bekende merken: ' + Object.keys(catalogus).join(', '));
    }
    kiesModel.disabled = modellen.length === 0;
  }

  function gekozenModel() {
    var modellen = catalogus[kiesMerk.value] || [];
    return modellen[parseInt(kiesModel.value, 10)] || null;
  }

  function melding(tekst) {
    var plek = uit.querySelector('span');
    if (!plek || !tekst) return;
    plek.textContent = tekst;
    uit.setAttribute('data-show', '');
  }

  kiesMerk.addEventListener('change', function () {
    uit.removeAttribute('data-show');
    if (!kiesMerk.value) {
      kiesModel.disabled = true;
      kiesModel.innerHTML = '<option>' +
        (kiesModel.dataset.eerst || 'Kies eerst een merk') + '</option>';
      return;
    }
    var handle = kiesMerk.value;
    kiesModel.disabled = true;
    window.VTCatalogus.laad().then(function (c) {
      catalogus = c || {};
      if (kiesMerk.value === handle) vulModellen(handle);
    }).catch(function () {
      kiesModel.disabled = true;
    });
  });
  kiesModel.addEventListener('change', function () {
    uit.removeAttribute('data-show');
  });

  knopGo.addEventListener('click', function () {
    if (!kiesMerk.value || !kiesModel.value) return;
    var m = gekozenModel();
    if (!m) return;

    var bekend = kiesModel.dataset.kzVoor === kiesMerk.value + '/' + kiesModel.value
      ? parseInt(kiesModel.dataset.kzIndex, 10) : NaN;
    var uitvoering = !isNaN(bekend) && m.varianten ? m.varianten[bekend] : null;
    var modelUrl = uitvoering && uitvoering.url ? uitvoering.url : m.url;

    if (hulp.dataset.naarModel === 'true' && modelUrl) {
      window.location.href = modelUrl;
      return;
    }
    if (!window.VTKabel || kabels.length === 0) {
      console.warn('[Voltrade] keuzehulp: geen kabels om mee te rekenen');
      return;
    }
    var analyse = VTKabel.analyseerModel(m);
    var auto = uitvoering ? VTKabel.autoVoor(m, analyse, String(bekend)) : analyse.auto;
    if (!auto) {
      if (modelUrl) { window.location.href = modelUrl; return; }
      melding((hulp.dataset.tekstGeenAdvies || '').replace(/\{\{\s*naam\s*\}\}/g, m.volnaam || m.naam));
      return;
    }
    var b = VTKabel.beste(auto, kabels);
    if (!b) return;
    window.location.href = b.kabel.filter_url || b.kabel.url;
  });
})();